export default __webpack_public_path__ + "static/media/welcome.5690d473.jpg";